<app-foldable-card [folded]="true">
  <div header>
    <h2 class="atmos-item-unlock-calc-sub__title">
      <mat-icon>auto_awesome</mat-icon> Add season items
    </h2>
  </div>
  <p class="atmos-paragraph">
    Select a season to quickly add all items from the season spirits to the calculator.<br/>
    Please note that the guide needs to be added separately.
  </p>
  <div class="atmos-item-unlock-calc-sub__season-list">
    @for (season of seasons; track season.guid) {
      <div class="atmos-btn-group">
        <button type="button" class="atmos-btn atmos-btn--sm atmos-item-unlock-calc-sub__season-btn"
          (click)="onSeasonSelected(season)">
          @if (season.iconUrl) {
            <app-icon [src]="season.iconUrl" width="20px" height="20px"></app-icon>
          }
          <span>{{ season.shortName }}</span>
        </button>
        <button type="button" class="atmos-btn atmos-btn--sm" (click)="onGuideSelected(season)">
          Guide
        </button>
      </div>
    }
  </div>
</app-foldable-card>
